import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MainComponent} from './pages/main/main.component';
import {UserGuard} from './_guard/user.guard';
import {RefreshComponent} from './refresh/refresh.component';
import {environment} from '../environments/environment';

const designPreviewRoutes: Routes = environment.production ? [] : [
  {
    path: 'design-preview/owner-monitoring',
    loadComponent: () => import('./pages/owner-monitoring/owner-monitoring.component').then(m => m.OwnerMonitoringComponent)
  },
  {
    path: 'design-preview/join-welcome',
    loadChildren: () => import('./pages/join/welcome/welcome.module').then(m => m.WelcomeModule)
  },
  {
    path: 'design-preview/join-sns',
    loadChildren: () => import('./pages/join/join-sns/join-sns.module').then(m => m.JoinSnsModule)
  },
  {
    path: 'design-preview/home-info',
    loadChildren: () => import('./pages/home/user-info/user-info.module').then(m => m.UserInfoModule)
  },
  {
    path: 'design-preview/home',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'design-preview/home-sns',
    loadChildren: () => import('./pages/home/sns/sns.module').then(m => m.SnsModule)
  },
  {
    path: 'design-preview/home-purchase',
    loadChildren: () => import('./pages/home/purchase/purchase.module').then(m => m.PurchaseModule)
  },
  {
    path: 'design-preview/home-coupon',
    loadChildren: () => import('./pages/home/coupon/coupon.module').then(m => m.CouponModule)
  },
  {
    path: 'design-preview/password-expired',
    loadChildren: () => import('./pages/account/password-expired/password-expired.module').then(m => m.PasswordExpiredModule)
  },
  {
    path: 'design-preview/house-list-empty',
    loadChildren: () => import('./pages/house/house-dashboard/house-list/house-list.module').then(m => m.HouseListModule)
  },
  {
    path: 'design-preview/analysis-list-empty',
    loadComponent: () => import('./analysis/pages/list/analysis-list/analysis-list.component').then(m => m.AnalysisListComponent)
  },
  {
    path: 'design-preview/analysis-step-01',
    loadComponent: () => import('./analysis/pages/create/tabs/analysis-report-type/analysis-report-type.component').then(m => m.AnalysisReportTypeComponent)
  },
  {
    path: 'design-preview/analysis-step-02',
    loadComponent: () => import('./analysis/pages/create/preview/analysis-flow-preview.component').then(m => m.AnalysisFlowPreviewComponent),
    data: {step: 2}
  },
  {
    path: 'design-preview/analysis-step-03',
    loadComponent: () => import('./analysis/pages/create/preview/analysis-flow-preview.component').then(m => m.AnalysisFlowPreviewComponent),
    data: {step: 3}
  },
  {
    path: 'design-preview/analysis-step-04',
    loadComponent: () => import('./analysis/pages/create/preview/analysis-flow-preview.component').then(m => m.AnalysisFlowPreviewComponent),
    data: {step: 4}
  },
  {
    path: 'design-preview/analysis-step-05',
    loadComponent: () => import('./analysis/pages/create/preview/analysis-flow-preview.component').then(m => m.AnalysisFlowPreviewComponent),
    data: {step: 5}
  },
  {
    // 결제 직후 정보 수집 상태를 API 호출 없이 확인하기 위한 개발 전용 미리보기 경로다.
    path: 'design-preview/analysis-collecting',
    loadComponent: () => import('./analysis/pages/loading/loading.component').then(m => m.AnalysisLoadingComponent)
  },
  {
    // 기본·정밀 분석의 모든 정보 입력 단계를 API 없이 확인하는 개발 전용 미리보기 경로다.
    path: 'design-preview/analysis-detail',
    loadComponent: () => import('./analysis/pages/detail/analysis-detail/preview/analysis-detail-preview.component').then(m => m.AnalysisDetailPreviewComponent)
  },
  {
    // 마이 부동산 대시보드의 반응형 화면을 백엔드 데이터 없이 검수하기 위한 개발 전용 경로다.
    path: 'design-preview/my-real-estate',
    loadComponent: () => import('./pages/my-real-estate/my-real-estate.component').then(m => m.MyRealEstateComponent)
  }
];

const routes: Routes = [
  ...designPreviewRoutes,
  {
    path: 'info/owner-monitoring',
    loadComponent: () => import('./pages/owner-monitoring/owner-monitoring-info.component').then(m => m.OwnerMonitoringInfoComponent)
  },
  {
    path: 'owner-monitoring',
    loadComponent: () => import('./pages/owner-monitoring/owner-monitoring.component').then(m => m.OwnerMonitoringComponent),
    canActivate: [UserGuard]
  },
  {path: '', component: MainComponent},
  {path: 'refresh', component: RefreshComponent},
  {path: 'join/sns', loadChildren: () => import('./pages/join/join-sns/join-sns.module').then(m => m.JoinSnsModule)},
  {path: 'join', loadChildren: () => import('./pages/join/join.module').then(m => m.JoinModule)},
  {path: 'account', loadChildren: () => import('./pages/account/account.module').then(m => m.AccountModule)},
  {
    path: 'coupon',
    loadComponent: () => import('./pages/coupon/coupon.component').then(c => c.CouponComponent),
    canActivate: [UserGuard]
  },
  {
    path: 'business-inquiry/owner-monitoring',
    loadComponent: () => import('./pages/owner-monitoring/owner-monitoring-application.component').then(m => m.OwnerMonitoringApplicationComponent)
  },
  {
    path: 'business-inquiry',
    loadComponent: () => import('./pages/business-inquiry/business-inquiry.component').then(m => m.BusinessInquiryComponent)
  },
  {
    path: 'inquire',
    loadChildren: () => import('./pages/inquire/inquire.module').then(m => m.InquireModule),
    canActivate: [UserGuard]
  },
  {
    path: 'house/register',
    loadChildren: () => import('./pages/house/house-register/house-register.module').then(m => m.HouseRegisterModule),
    canActivate: [UserGuard]
  },
  {
    path: 'house/batch',
    loadChildren: () => import('./pages/house/house-excel-register/house-excel-register.module').then(m => m.HouseExcelRegisterModule),
    canActivate: [UserGuard]
  },
  {
    path: 'house/detail',
    loadChildren: () => import('./pages/house/house-detail/house-detail.module').then(m => m.HouseDetailModule),
    canActivate: [UserGuard]
  },
  {
    path: 'house/extends',
    loadChildren: () => import('./pages/house/house-extends/house-extends.module').then(m => m.HouseExtendsModule),
    canActivate: [UserGuard]
  },
  {
    path: 'house/open',
    loadChildren: () => import('./pages/house/house-open-list/house-open-list.module').then(m => m.HouseOpenListModule)
  },
  {
    path: 'house',
    loadChildren: () => import('./pages/house/house-dashboard/house-dashboard.module').then(m => m.HouseDashboardModule),
    canActivate: [UserGuard]
  },
  {
    path: 'analysis/info',
    loadComponent: () => import('./analysis/pages/info/analysis-info.component').then(m => m.AnalysisInfoComponent)
  },
  {
    path: 'analysis',
    loadChildren: () => import('./analysis/pages/analysis.module').then(m => m.AnalysisModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule),
    canActivate: [UserGuard]
  },
  {
    // 기존 서비스 API만 조합하는 통합 대시보드로 DB 및 백엔드 수정이 필요하지 않다.
    path: 'my-real-estate',
    loadComponent: () => import('./pages/my-real-estate/my-real-estate.component').then(m => m.MyRealEstateComponent),
    canActivate: [UserGuard]
  },
  {
    path: 'info/my-house',
    loadChildren: () => import('./pages/info/my-house/my-house.module').then(m => m.MyHouseModule)
  },
  {
    path: 'info/open-house',
    loadChildren: () => import('./pages/info/open-house/open-house.module').then(m => m.OpenHouseModule)
  },
  {path: 'info/events', loadChildren: () => import('./pages/info/notice/notice.module').then(m => m.NoticeModule)},
  {path: 'info/notice', loadChildren: () => import('./pages/info/notice/notice.module').then(m => m.NoticeModule)},
  {path: 'info/update', loadChildren: () => import('./pages/info/notice/notice.module').then(m => m.NoticeModule)},
  {path: 'info/company', loadChildren: () => import('./pages/info/company/company.module').then(m => m.CompanyModule)},
  {path: 'info/faq', loadComponent: () => import('./pages/info/faq/faq.component').then(m => m.FaqComponent)},
  {
    path: 'info/business-analysis',
    loadComponent: () => import('./pages/info/business-analysis/business-analysis-info.component').then(m => m.BusinessAnalysisInfoComponent)
  },
  {
    path: 'info/business-analysis-preview',
    loadComponent: () => import('./pages/info/business-analysis/preview/business-analysis-preview.component').then(m => m.BusinessAnalysisPreviewComponent)
  },
  {
    path: 'info/business-analysis-private',
    loadComponent: () => import('./analysis/pages/info/private/analysis-private-info.component').then(m => m.AnalysisPrivateInfoComponent)
  },
  {
    path: 'info/business-analysis-bridge',
    loadComponent: () => import('./analysis/pages/info/bridge/analysis-bridge-info.component').then(m => m.AnalysisBridgeInfoComponent)
  },
  {path: 'info/api', loadComponent: () => import('./pages/info/api/api-info.component').then(m => m.ApiInfoComponent)},
  {
    path: 'info/guide-boards',
    loadComponent: () => import('./pages/info/guide-board/list/guide-board-list.page').then(m => m.GuideBoardListPage)
  },
  {
    path: 'info/guide-boards/detail',
    loadComponent: () => import('./pages/info/guide-board/detail/guide-board.page').then(m => m.GuideBoardPage)
  },
  {
    path: 'info/pricing',
    loadComponent: () => import('./pages/info/pricing/pricing.component').then(m => m.PricingComponent)
  },
  {
    path: 'notification',
    loadChildren: () => import('./pages/notification/notification.module').then(m => m.NotificationModule),
    canActivate: [UserGuard]
  },
  {path: 'terms', loadChildren: () => import('./pages/terms/terms.module').then(m => m.TermsModule)},
  {
    path: 'toss/payment',
    loadComponent: () => import('./pages/toss/toss-payment.component').then(c => c.TossPaymentComponent)
  },
  {
    path: 'toss/auto-billing',
    loadComponent: () => import('./pages/toss/auto-billing/handler/auto-billing-handler.component').then(c => c.AutoBillingHandlerComponent)
  },
  {
    path: 'calculator',
    loadChildren: () => import('./pages/calculator/calculator.module').then(m => m.CalculatorModule)
  },
  {
    path: 'real-estate-calculator',
    loadChildren: () => import('./pages/real-estate-calculator/real-estate-calculator.module').then(m => m.RealEstateCalculatorModule)
  },
  {
    path: 'scorer',
    loadComponent: () => import('./scorer/pages/address/scorer-address.page').then(c => c.ScorerAddressPage)
  },
  {
    path: 'info/scorer',
    loadComponent: () => import('./scorer/pages/info/scorer-info.component').then(c => c.ScorerInfoComponent)
  },
  {
    // 위클리 부동산 리포트(사용자 공개 페이지). report-api(별도 S2S)를 프록시 경유로 소비한다.
    path: 'report',
    loadComponent: () => import('./pages/report/report.component').then(m => m.ReportComponent)
  },
  {
    // 월간 리포트(F-M2). /report/monthly = 최신호. 같은 카드 부품을 월간 어휘로 조합한다.
    path: 'report/monthly',
    loadComponent: () => import('./pages/report/monthly-report.component').then(m => m.MonthlyReportComponent)
  },
  {
    // 월간 리포트 과거호. /report/monthly/:year/:month (예: /report/monthly/2026/8).
    path: 'report/monthly/:year/:month',
    loadComponent: () => import('./pages/report/monthly-report.component').then(m => m.MonthlyReportComponent)
  },
  {
    // 관심지역 상세분석 (화면설계서 7~13p). :code 없으면 컴포넌트가 기본 관심지역(강남)으로 뜬다.
    path: 'report/region/:code',
    loadComponent: () => import('./pages/region-detail/region-detail.component').then(m => m.RegionDetailComponent)
  },
  {
    path: 'report/region',
    loadComponent: () => import('./pages/region-detail/region-detail.component').then(m => m.RegionDetailComponent)
  },
  {path: '**', redirectTo: '/'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'top', onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
